// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// RESPONSIVE VIDEO!


//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = window.innerHeight;

      // window.addEventListener("resize", function() {
      //   if (window.matchMedia("(min-width: 600px) and (max-width: 899px").matches) {
      //     offsetValue = 700;
      //   } else if (window.matchMedia("(min-width: 900px) and (max-width: 1919px").matches) {
      //     offsetValue = 675;
      //   } else if (window.matchMedia("(min-width: 1920px)").matches) {
      //     offsetValue = 1080;
      //   } else {
      //     offsetValue = 645; // mobile
      //   }
      // });

      $('html,body').animate({
        scrollTop: target.offset().top + offsetValue
      }, 2000);
      return false;
    }
  }
});


//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById('msdw-video-responsive');

function loadVideo() {
  var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
      md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
      lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
      xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if      (sm.matches) { changeVideoSize('sm') }
  else if (md.matches) { changeVideoSize('md') }
  else if (lg.matches) { changeVideoSize('lg') }
  else if (xl.matches) { changeVideoSize('xl') }
}

function changeVideoSize(size){
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-"+size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener('DOMContentLoaded', loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
}

// window.addEventListener('resize', () => vid.attr('hidden' = true));
